var _style, _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 218 182",
    style: {
      enableBackground: "new 0 0 218 182"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192,109.3c0,14-11.4,25.4-25.4,25.4H28.4V34.1c0-14,11.4-25.4,25.4-25.4H192V109.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.2719,
    y1: 81.0636,
    x2: 175.2211,
    y2: 81.0636,
    gradientTransform: "matrix(1.125 0 0 1.125 -14.1005 -12.4865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    style: {
      stopColor: "#00873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#40A737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CB531"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147,83.5h10.5c0.3,0,1-0.1,1.3-0.1c2-0.4,3.7-2.2,3.7-4.7c0-2.4-1.7-4.2-3.7-4.7c-0.3-0.1-0.9-0.1-1.3-0.1 H147V83.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.2733,
    y1: 74.8365,
    x2: 175.2207,
    y2: 74.8365,
    gradientTransform: "matrix(1.125 0 0 1.125 -14.1005 -12.4865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    style: {
      stopColor: "#00873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#40A737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CB531"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.3,17.2c-10,0-18.2,8.1-18.2,18.2v18.9h25.7c0.6,0,1.3,0,1.8,0.1c5.8,0.3,10.1,3.3,10.1,8.5 c0,4.1-2.9,7.6-8.3,8.3v0.2c5.9,0.4,10.4,3.7,10.4,8.8c0,5.5-5,9.1-11.6,9.1h-28.2v37h26.7c10,0,18.2-8.1,18.2-18.2V17.2H156.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.2718,
    y1: 68.0635,
    x2: 175.2175,
    y2: 68.0635,
    gradientTransform: "matrix(1.125 0 0 1.125 -14.1005 -12.4865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    style: {
      stopColor: "#00873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#40A737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CB531"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.2,64.1c0-2.4-1.7-4-3.7-4.3c-0.2,0-0.7-0.1-1-0.1H147v8.8h9.5c0.3,0,0.9,0,1-0.1 C159.5,68.1,161.2,66.5,161.2,64.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.8469,
    y1: 74.8365,
    x2: 86.4106,
    y2: 74.8365,
    gradientTransform: "matrix(1.125 0 0 1.125 -14.1005 -12.4865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F286F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    style: {
      stopColor: "#004E94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    style: {
      stopColor: "#0066B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006FBC"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.7,17.2c-10,0-18.2,8.1-18.2,18.2v44.9c5.1,2.5,10.4,4.1,15.7,4.1c6.3,0,9.7-3.8,9.7-9V54.2h15.6v21.1 c0,8.2-5.1,14.9-22.4,14.9c-10.5,0-18.7-2.3-18.7-2.3v38.3h26.7c10,0,18.2-8.1,18.2-18.2V17.2H55.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.3472,
    y1: 74.8365,
    x2: 129.7425,
    y2: 74.8365,
    gradientTransform: "matrix(1.125 0 0 1.125 -14.1005 -12.4865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6C2C2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    style: {
      stopColor: "#882730"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    style: {
      stopColor: "#BE1833"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    style: {
      stopColor: "#DC0436"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E60039"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106,17.2c-10,0-18.2,8.1-18.2,18.2v23.8c4.6-3.9,12.6-6.4,25.5-5.8c6.9,0.3,14.3,2.2,14.3,2.2v7.7 c-3.7-1.9-8.1-3.6-13.8-4c-9.8-0.7-15.7,4.1-15.7,12.5c0,8.5,5.9,13.3,15.7,12.5c5.7-0.4,10.1-2.2,13.8-4v7.7 c0,0-7.3,1.9-14.3,2.2c-12.9,0.6-20.9-1.9-25.5-5.8v42h26.7c10,0,18.2-8.1,18.2-18.2V17.2H106z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,151.3v13c0,2.2,0.5,3.2,0.9,3.8c1.3,1.7,3.3,2.1,4.8,2.1c5.7,0,5.7-4.4,5.7-5.9v-12.8h2.8v12.9 c0,1.1,0,3.5-1.7,5.6c-2.1,2.6-5.2,2.9-6.8,2.9c-2,0-5.4-0.5-7.4-3.3c-0.6-0.9-1.2-2.1-1.2-5.3v-12.8H11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.8,159.3l0-1.7h2.7l0,2.3c0.3-0.6,1.4-2.6,4.7-2.6c1.3,0,5.3,0.5,5.3,5v9.9h-2.8v-9.2 c0-1-0.1-1.8-0.8-2.5c-0.7-0.7-1.7-1-2.6-1c-2,0-3.8,1.4-3.8,4.3v8.4h-2.7V159.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.1,151.3h3.3v3h-3.3V151.3z M47.4,157.6h2.7v14.5h-2.7V157.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.1,157.6c0,0.6-0.1,1.9-0.1,2.4v17.8h-2.8v-7.2c-0.2,0.3-0.5,0.8-1.2,1.2c-1.2,0.8-2.6,0.9-3.3,0.9 c-3.5,0-6.6-2.5-6.6-7.9c0-5.4,3-7.4,6.1-7.4c3,0,4.3,1.6,5,2.6l0.1-2.4H68.1z M61,159.4c-3.9,0-4,4.1-4,5.2c0,1,0.1,3.2,1.2,4.6 c0.6,0.9,1.8,1.4,3.1,1.4c3.4,0,4-2.6,4-5.5C65.4,164,65.4,159.4,61,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.9,157.6v9.4c0,1.4,0.3,3.2,3.1,3.2c1.4,0,2.6-0.5,3.4-1.6c0.6-0.9,0.6-2,0.6-2.7v-8.2h2.8v11.8 c0,0.3,0.1,1.9,0.1,2.7h-2.8l-0.1-2.5c-0.5,1-1.5,2.6-4.6,2.6c-3.6,0-5.3-2.1-5.3-4.9v-9.8H75.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.9,165.4c-0.1,3,1.2,5.2,4.2,5.2c1.8,0,3.2-0.9,3.4-3h2.7c-0.1,0.7-0.2,1.9-1.2,3c-0.6,0.7-2.1,1.9-5,1.9 c-4.6,0-6.8-2.8-6.8-7.4c0-2.9,0.6-5.2,2.9-6.8c1.4-1,3.1-1.1,4-1.1c6.5,0,6.4,5.8,6.3,8.1H92.9z M100.5,163.5 c0-1.4-0.2-4.3-3.6-4.3c-1.8,0-3.9,1.1-4,4.3H100.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.9,151.3h2.7v20.9h-2.7V151.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.1,172.3l-2.1,5.4h-2.8l2.2-5.6l-6.1-14.5h3.1l4.6,11.5l4.6-11.5h3L122.1,172.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.1,164l-8.2-12.7h3.6l6.2,10.3l6.3-10.3h3.2l-8.2,12.8v8.1h-2.9V164z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.1,157.3c5.8,0,7.1,4.6,7.1,7.6c0,4.3-2.4,7.8-7.4,7.8c-4.8,0-7.2-3.3-7.2-7.6 C152.7,161.5,154.4,157.3,160.1,157.3z M159.9,170.6c2.1,0,4.4-1.5,4.4-5.9c0-3.6-1.7-5.5-4.2-5.5c-1.7,0-4.5,1.1-4.5,5.7 C155.5,167.9,156.8,170.6,159.9,170.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.1,157.6v9.4c0,1.4,0.3,3.2,3.1,3.2c1.4,0,2.6-0.5,3.4-1.6c0.6-0.9,0.6-2,0.6-2.7v-8.2h2.8v11.8 c0,0.3,0.1,1.9,0.1,2.7h-2.8l-0.1-2.5c-0.5,1-1.5,2.6-4.6,2.6c-3.6,0-5.3-2.1-5.3-4.9v-9.8H174.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.5,160.6c0-1-0.1-2-0.1-3h2.8l0.1,2.8c0.5-2,2.3-2.7,3.5-2.9c0.8-0.1,1.4-0.1,1.9-0.1v2.7 c-0.1-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.5,0-0.8,0c-3.2,0-4,1.9-4,4.4v7.7h-2.8V160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.3,167.9c0,1.1,0.6,2.6,3.2,2.6c1.1,0,2-0.2,2.6-0.9c0.3-0.4,0.5-0.9,0.5-1.4c0-1.4-1-1.7-3.2-2.2 c-3-0.7-5.6-1.3-5.6-4.3c0-2.7,2.3-4.4,5.7-4.4c1.8,0,4.4,0.5,5.2,2.3c0.4,0.8,0.4,1.5,0.4,2.1h-2.8c0.1-2.2-1.8-2.4-2.8-2.4 c-0.4,0-3,0-3,2.1c0,1.3,1.3,1.7,2.1,1.9c4,1,4.9,1.2,5.8,2c0.8,0.8,1.1,1.8,1.1,2.7c0,1.6-0.9,3-2,3.7c-1.3,0.8-2.8,1-4.3,1 c-3,0-5.7-1.2-5.7-4.7H202.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbLogo);
export default __webpack_public_path__ + "static/media/jcb_logo.657e909e1fe8d5220a8bd1074379cab3.svg";
export { ForwardRef as ReactComponent };